export default "__VITE_ASSET__255c09cc__"